export default __webpack_public_path__ + "static/Malaysia-39bba9530d50bc15c0199967df580a81.png";